export const BitcoinLanderViewed = (investmentProduct: string) => ({
  feature: 'Bitcoin Onboarding',
  event_description: 'Bitcoin Lander Viewed',
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'bitcoinLander',
  screen: 'bitcoinLander',
  screen_name: 'bitcoinLander',
  investment_product: investmentProduct,
})

export const BitcoinLanderButtonTapped = (investmentProduct: string) => ({
  feature: 'Bitcoin Onboarding',
  event_description: 'Bitcoin Lander Add To Your Portfolio CTA Tapped',
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'bitcoinAddToYourPortfolioCTA',
  screen: 'bitcoinLander',
  screen_name: 'bitcoinLander',
  investment_product: investmentProduct,
})

export const BitcoinLanderModalButtonTapped = (investmentProduct: string) => ({
  feature: 'Bitcoin Onboarding',
  event_description: 'Bitcoin Add To Your Portfolio Modal CTA Tapped',
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'bitcoinAddToYourPortfolioModalCTA',
  screen: 'bitcoinAddToYourPortfolioModal',
  screen_name: 'bitcoinAddToYourPortfolioModal',
  investment_product: investmentProduct,
})
